(() => {
    try {
        const url = new URL(document.location.href);

        const buttons = document.getElementsByClassName('btn btn-success btn-checkout-next');
        const checkoutSection = document.getElementById('checkout');
        if (!checkoutSection) {
            return;
        }
        const checkoutForm = checkoutSection.getElementsBySelector('#onestepcheckout-form')[0];
        if (!checkoutForm) {
            return;
        }

        const steps = checkoutForm.getElementsBySelector('div.step');
        const getStepData = (step) => {
            const elements = step.getElementsBySelector('textarea, input, select');
            const data = elements.reduce((acc, item) => {
                if (!item.name) {
                    window.__haftahave.__hh_debug && console.log(`${item.tagName} element has no name:`, item);
                    return acc;
                }

                if (acc[item.name]) {
                    window.__haftahave.__hh_debug && console.log(`${item.tagName} element has duplicate name:`, item);
                    return acc;
                }

                acc[item.name] = item.value;
                return acc;
            }, {});

            return data;
        };
        const getFormData = () => {
            const data = {
                card: getStepData(steps[0]),
                delivery: getStepData(steps[1]),
                payment: getStepData(steps[2]),
            };

            return data;
        };
        const sendRequest = (phone, domain) => {
            const params = {
                type: 'customer_phone',
                data: {
                    customerPhone: phone,
                    domain,
                },
            };

            // send event to api gateway
            const xhr = new XMLHttpRequest();
            xhr.open('POST', process.env.HH_AWS_API_GATEWAY_TRACKING, true);
            xhr.setRequestHeader('Content-type', 'application/json');
            xhr.send(JSON.stringify(params));
        };
        const addToCollection = (collection, type, handler) => {
            for (const item of collection) { // eslint-disable-line
                item.addEventListener(type, handler);
            }
        };
        const removeFromCollection = (collection, type, handler) => {
            for (const item of collection) { // eslint-disable-line
                item.removeEventListener(type, handler);
            }
        };
        const clickHandler = () => {
            const data = getFormData();
            const phone = data.payment['billing[telephone]'] || null;

            const specialPhones = ['(111) 111-1111', '(222) 222-2222'];
            const hasPhone = Boolean(phone && phone.length >= 6 && specialPhones.includes(phone));
            if (hasPhone) {
                removeFromCollection(buttons, 'click', clickHandler);
                sendRequest(phone, url.origin);
            }
        };

        addToCollection(buttons, 'click', clickHandler);
    } catch (error) {
        // mute errors
    }
})();
